/* eslint-disable react/display-name, react/no-multi-comp */
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Row, Col } from '@app/ui';

import Modal from '../components/common/modals/Modal';
import ModalBody from '../components/common/modals/ModalBody';
import ModalHeader from '../components/common/modals/ModalHeader';
import shortenStr from '../utils/shortenStr';

const container = document.getElementById('client-settings-upload-modal');

const UploadModal = ({ uploads, errors }) => {
    const { t } = useTranslation('settings');
    return ReactDOM.createPortal(
        <Modal>
            <ModalHeader
                title={t('clientConfiguration.uploadModal.title')}
                noButton
            />
            <ModalBody className="-p-a-0 -m-a-2">
                {uploads.map((u, index) => {
                    const progress = u?.progress || 0;
                    const hasErrored = !!errors.find(e => e?.path === u?.path);
                    const name = `${shortenStr(30, u?.name || '')}`;
                    return (
                        <Fragment key={`${u.name}_${index}`}>
                            {!hasErrored && (
                                <Row gutter={16} className="-m-a-1">
                                    <Col md={10}>
                                        <div className="gds-flex gds-flex--align-center">
                                            <div className="gds-flex__item gds-flex__item--grow-0">
                                                <p
                                                    className="-m-b-0"
                                                    htmlFor="input-2"
                                                >
                                                    {name}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={10}>
                                        <div className="gds-flex gds-flex--align-center">
                                            <div className="gds-flex__item gds-flex__item--grow-1">
                                                <div
                                                    className="gds-progress-bar gds-progress-bar--secondary gds-progress-bar--xs -m-v-2"
                                                    data-value={`${progress}`}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="gds-flex gds-flex--align-center">
                                            <div className="gds-flex__item gds-flex__item--grow-0">
                                                <p
                                                    className="-m-b-0"
                                                    htmlFor="input-2"
                                                >
                                                    {`${progress} %`}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Fragment>
                    );
                })}
            </ModalBody>
        </Modal>,
        container,
    );
};

UploadModal.propTypes = {
    uploads: PropTypes.array,
    errors: PropTypes.array,
};

export default UploadModal;
